import { apiRequest } from "./apiClient";
import { localScheduleFields } from "./scheduledNotificationService";
import { currentTimeZonePayload } from "../hooks/useUserTimezone";

const normalizeScheduledDateForStorage = (value) => {
  if (!value) return "";
  const date = value?.toDate ? value.toDate() : new Date(value);
  return Number.isNaN(date.getTime()) ? "" : date.toISOString();
};

const normalizeDateValue = (value) => {
  if (!value) return "";
  if (typeof value === "string") return value;
  if (value?.toDate) return value.toDate().toISOString();
  try { return new Date(value).toISOString(); } catch { return ""; }
};

const sortByPlannedDate = (a, b) =>
  String(normalizeDateValue(a.planlananTarih) || "").localeCompare(
    String(normalizeDateValue(b.planlananTarih) || "")
  );

export async function bekleyenZamanlanmisBildirimleriGetir(familyId = null) {
  const params = new URLSearchParams();
  if (familyId) params.set("familyId", familyId);
  const data = await apiRequest(`/notifications/admin/scheduled${params.toString() ? `?${params}` : ""}`);
  return (data?.items || []).sort(sortByPlannedDate);
}

export async function zamanlanmisBildirimiGuncelle(id, data = {}) {
  if (!id) return;
  const payload = {
    ...data,
    durum: data.durum || "bekliyor",
  };
  if (Object.prototype.hasOwnProperty.call(data, "planlananTarih")) {
    payload.planlananTarih = normalizeScheduledDateForStorage(data.planlananTarih);
    Object.assign(payload, localScheduleFields(data.planlananTarih), {
      scheduleMode: "recipient_local",
      scheduleTimezone: currentTimeZonePayload().timeZone,
    });
  }
  await apiRequest(`/notifications/admin/scheduled/${encodeURIComponent(String(id))}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export async function zamanlanmisBildirimiIptalEt(id) {
  if (!id) return;
  await apiRequest(`/notifications/admin/scheduled/${encodeURIComponent(String(id))}`, { method: "DELETE" });
}

export async function zamanlanmisBildirimiSil(id) {
  if (!id) return;
  await apiRequest(`/notifications/admin/scheduled/${encodeURIComponent(String(id))}?hard=true`, { method: "DELETE" });
}
